import { baseApi as api } from "./generated/baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getGeoLocation: builder.query({
      query: () => 'https://d2ppky5xv7yipj.cloudfront.net/GeoStage/GeoLocation',
    }),
  }),
});

export const { useGetGeoLocationQuery } = injectedRtkApi;